import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { DirectivesModule } from '@shared/directives/directives.module';
import { ButtonModule } from '@shared/components/button/button.module';
import {
  FormFieldCrudControlsModule
} from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { CustomFieldResponsibilityListComponent } from './custom-field-responsibility-list.component';
import { SelectModule } from '../../form/select/select.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DirectivesModule,
    SelectModule,
    FormlyModule,
    FormFieldCrudControlsModule,
    NgbModule
  ],
  declarations: [CustomFieldResponsibilityListComponent],
  exports: [CustomFieldResponsibilityListComponent]
})
export class CustomFieldResponsibilityListModule { }
